"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPickerWrapper = void 0;
const react_1 = __importStar(require("react"));
require("./index.scss");
const className = 'input-dates-wrapped';
const useOutsideClickHandler = (ref, handleOutsideClick) => {
    const handleOutsideClickRef = (0, react_1.useRef)(handleOutsideClick);
    handleOutsideClickRef.current = handleOutsideClick;
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            var _a;
            if (ref.current && !ref.current.contains(event.target)) {
                (_a = handleOutsideClickRef.current) === null || _a === void 0 ? void 0 : _a.call(handleOutsideClickRef);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
};
const DayPickerWrapper = (props) => {
    const wrapperRef = (0, react_1.useRef)(null);
    useOutsideClickHandler(wrapperRef, props.onOutsideClick);
    return (react_1.default.createElement("div", { className: className, ref: wrapperRef }, props.children));
};
exports.DayPickerWrapper = DayPickerWrapper;
//# sourceMappingURL=index.js.map